export const LOAD_PLANTS = "LOAD_PLANTS";
export const LOAD_PLANTS_SUCCESS = "LOAD_PLANTS_SUCCESS";
export const LOAD_PLANTS_ERROR = "LOAD_PLANTS_ERROR";
export const UPDATE_PLANT = "UPDATE_PLANT";
export const UPDATE_PLANT_SUCCESS = "UPDATE_PLANT_SUCCESS";
export const DELETE_PLANT = "DELETE_PLANT";
export const DELETE_PLANT_SUCCESS = "DELETE_PLANT_SUCCESS";
